import * as React from 'react'

import { Box, Button, Icon, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

interface Props {
  onDeleteFile: () => void
  file: File
  defaultName: string
  renderIcon?: (file: File) => React.ReactNode
  error?: string
}

const Item = ({ file, onDeleteFile, defaultName, renderIcon, error = undefined }: Props) => {
  const defaultIcon = error ? 'alert-circle' : 'file'

  const defaultIconColor = error ? 'radicalRed1000' : undefined

  const buttonType = error ? 'primary' : 'secondary'

  return (
    <Box
      alignItems="center"
      flexDirection="row"
      gap="s16"
      paddingY="s12"
      paddingX="s16"
      width="full"
    >
      <Box>
        {!renderIcon && <Icon.Medium icon={defaultIcon} color={defaultIconColor} />}
        {renderIcon && renderIcon(file)}
      </Box>
      <Box flexGrow>
        <Text size="200" weight="normal" ellipsis overflowWrap>
          {file.name || defaultName}
        </Text>
      </Box>
      <Button type={buttonType} onClick={() => onDeleteFile()} iconName="delete" />
    </Box>
  )
}

export default observer(Item)
